import React from 'react';
import {
  CollapsibleSection,
  DatePicker,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@roger/ui-components';
import type { AvailableClinician } from '../../services/api';
import { getClinicianDisplayName } from '../../utils/clinicianUtils';
import type {
  InfectionLogFormState,
  UpdateInfectionLogField,
} from './infectionLogForm';
import { InfectionFieldLabel } from './infectionLogFormFields';

interface InfectionFollowUpSectionProps {
  form: InfectionLogFormState;
  updateField: UpdateInfectionLogField;
  clinicians: AvailableClinician[];
}

const InfectionFollowUpSection: React.FC<InfectionFollowUpSectionProps> = ({
  form,
  updateField,
  clinicians,
}) => (
  <CollapsibleSection title='Follow-Up' defaultOpen={false}>
    <div className='space-y-3'>
      <div>
        <InfectionFieldLabel>Follow-Up Due Date</InfectionFieldLabel>
        <DatePicker
          date={form.followUpDueDate}
          onDateChange={d => updateField('followUpDueDate', d)}
        />
      </div>
      <div>
        <InfectionFieldLabel>Follow-Up Assigned To</InfectionFieldLabel>
        <Select
          value={form.followUpAssigneeId}
          onValueChange={v => updateField('followUpAssigneeId', v)}
        >
          <SelectTrigger>
            <SelectValue placeholder='Select' />
          </SelectTrigger>
          <SelectContent>
            {clinicians.map(c => (
              <SelectItem key={c.id} value={c.id}>
                {getClinicianDisplayName(c)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  </CollapsibleSection>
);

export default InfectionFollowUpSection;
